import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Glassmorphism theme styles used across the application
  const theme = {
    // Container styles with glassmorphism effect
    glassContainer: "bg-white/20 dark:bg-black/20 backdrop-blur-lg border border-white/30 dark:border-white/20",
    
    // Card styles with glassmorphism
    glassCard: "bg-white/20 dark:bg-black/20 backdrop-blur-lg rounded-lg shadow-xl border border-white/30 dark:border-white/20",
    
    // Header/section backgrounds
    glassHeader: "bg-white/10 dark:bg-black/10 backdrop-blur-xl",
    
    // Interactive elements (buttons, etc.)
    glassInteractive: "bg-white/20 dark:bg-black/20 backdrop-blur-lg hover:bg-white/30 hover:dark:bg-black/30 border border-white/30 dark:border-white/20",
    
    // Selected/active state
    glassActive: "bg-white/30 dark:bg-white/20 backdrop-blur-xl shadow-lg border border-white/40 dark:border-white/30",
    
    // Search/input containers
    glassInput: "bg-white/20 dark:bg-black/20 backdrop-blur-lg rounded-full border border-white/30 dark:border-white/20",
    
    // Text colors that work well with glassmorphism
    text: {
      primary: "text-gray-800 dark:text-white",
      secondary: "text-gray-600 dark:text-gray-300",
      muted: "text-gray-500 dark:text-gray-400"
    },
    
    // Spacing and layout helpers
    spacing: {
      container: "p-4",
      card: "p-4",
      section: "mb-6"
    }
  };

  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
};